import React from 'react';
import { Toolbar } from 'primereact/toolbar';


// import {NousContacter} from '../Dialog/nousContacter';

import './toolBar.css';

export default function ToolBar () {
    //const [openDialog, setDialog] = useState(false);
         const leftContents = (
        <React.Fragment>
      <a href='https://gexonline.gexpertise.fr/'><img alt="logo" src="/gexonline.png" height="40" className="p-mr-2"  /></a>
      
           
        </React.Fragment>
    );
    //const onHide = () => {
        //setDialog(false);
      
    //}
    // const renderFooter = () => {
    //     return (
    //         <div className='btnContact'>
    //             <Button label="Annuler"  onClick={() => onHide()} className="p-button-text" />
    //             <Button label="Envoyer"  onClick={() => onHide()} autoFocus />
    //         </div>
    //     );
    // }
//const onClick = ()=> {
    //setDialog(true);
//}
    const rightContents = (
        <React.Fragment>
            
            {/* <Button  label="Se connecter"  className="p-button-text"/> */}
            
        </React.Fragment>
    );
    return (
        <div className="toolBar">
        <Toolbar left={leftContents} right={rightContents}  />
        {/*<Dialog header="Contactez-nous" visible={openDialog} style={{ width: '100%' }}  onHide={() => onHide('openDialog')} >*/}
            {/*<NousContacter setDialog={setDialog} />*/}
            {/*</Dialog>*/}
       </div>
    )
}